// The visitor's HUD on a friend's screens (owner 2026-10-27: on a visit "it should all keep its style", with
// Znajomi and your own money): the same Znajomi button and coin pill as at home, whose place it is in the wooden
// badge at the top, and "Wróć do siebie" as a wooden button right under Znajomi, lined up with it (owner 2026-10-27).
import { SCENE } from '../config.js';
import { visitState } from '../state/visitState.js';
import { MoneyBar } from './MoneyBar.js';
import { attachFriendsButton } from './FriendsButton.js';
import { gameButton, hudBadge } from './gameUi.js';
import { pinToCamera } from './pin.mjs';
import { MAIN_SPAWN_AT_STAIRS } from '../scenes/mainLayout.js';

// Znajomi is 190×44 at (20, 20) (FriendsButton.js); this one is the same size and column, just below it.
const BACK = { x: 20 + 95, y: 92, w: 190, h: 44 };

// Returns the badge's text, for a screen that changes it later (the farm: the host's level).
export function attachVisitHud(scene, title) {
  new MoneyBar(scene);
  attachFriendsButton(scene);
  const { text } = hudBadge(scene, { textY: 31 });
  text.setText(title);
  // Home means your own front yard, at the foot of your stairs (owner 2026-10-27: not the street; 2026-10-28: where
  // walking up goes straight in, as arriving at a friend's). Pinned with its children: the wide Podwórko scrolls,
  // and a container child hit-tests with its own scroll factor.
  const back = gameButton(scene, BACK.x, BACK.y, BACK.w, BACK.h, 'Wróć do siebie {house}', () => {
    visitState.reset();
    scene.scene.start(SCENE.MAIN, { spawnX: MAIN_SPAWN_AT_STAIRS.x, spawnFeetY: MAIN_SPAWN_AT_STAIRS.feetY });
  }, { variant: 'wood', fontSize: 17 });
  pinToCamera(back).setDepth(100);
  return text;
}
